import TileGrid from '@/components/TileGrid';
import FileTile from '../FileTile';
import type { Tile } from '../types';

export type FileTileGridProps = {
  baseCollectionId: number;
  tiles: Tile[];
  onCloseTile: (tileId: string) => void;
};

export default function FileTileGrid({
  baseCollectionId,
  tiles,
  onCloseTile,
}: FileTileGridProps) {
  const compact = tiles.length > 1;

  return (
    <TileGrid>
      {tiles.map((tile) => (
        <FileTile
          key={tile.tileId}
          compact={compact}
          baseCollectionId={baseCollectionId}
          initialFileId={tile.initialFileId}
          onClose={() => onCloseTile(tile.tileId)}
        />
      ))}
    </TileGrid>
  );
}
